import { defineComponent, h, useAttrs } from 'vue'
import { VSnackbar } from 'vuetify/components'
import { hasBooleanishAttr } from './legacyInputProps'

VSnackbar.compatConfig = {
  ...(VSnackbar.compatConfig || {}),
  COMPONENT_V_MODEL: false
}

function normalizeAttrs(attrs) {
  const normalized = { ...attrs }
  normalized.modelValue = attrs.modelValue ?? attrs.value

  if (hasBooleanishAttr(attrs.top) && normalized.location == null) {
    normalized.location = 'top center'
  }
  if (hasBooleanishAttr(attrs.bottom) && normalized.location == null) {
    normalized.location = 'bottom center'
  }
  if (hasBooleanishAttr(attrs.left) && normalized.location == null) {
    normalized.location = 'bottom start'
  }
  if (hasBooleanishAttr(attrs.right) && normalized.location == null) {
    normalized.location = 'bottom end'
  }

  delete normalized.value
  delete normalized.top
  delete normalized.bottom
  delete normalized.left
  delete normalized.right

  return normalized
}

export default defineComponent({
  name: 'VSnackbarCompat',
  compatConfig: {
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  },
  inheritAttrs: false,
  emits: ['update:modelValue', 'input'],

  setup(_, { emit, slots }) {
    const attrs = useAttrs()

    return () =>
      h(
        VSnackbar,
        {
          ...normalizeAttrs(attrs),
          'onUpdate:modelValue': (value) => {
            emit('update:modelValue', value)
            emit('input', value)
          }
        },
        slots
      )
  }
})
